import React, { Component } from 'react';
import PropTypes from 'prop-types';
class MyTraderaMenu extends Component {

    state = {
        show: false,
        hoverContainer: false
    };

    toggleShow = show => {
        window.clearTimeout(this.toggleShowTimeoutId);
        this.toggleShowTimeoutId = window.setTimeout(() => {
            if (this.state.show !== show) {
                this.setState({ show: show });
            }
        }, 100);
    }

    componentWillReceiveProps(nextProps) {
        this.toggleShow(nextProps.hoverUser);
    }

    onMouseOverContainer = () => {
        this.toggleShow(true);
    }

    onMouseOutContainer = () => {
        this.toggleShow(false);
    }

    render() {
        const {
            memberId,
            cleanedMemberAlias
        } = this.props;
        return (
            <div className="site-header-menu-links-container" onMouseOver={this.onMouseOverContainer} onMouseOut={this.onMouseOutContainer} data-main-myt-menu>
                <nav className={`dropdown-area site-header-menu-links ${this.state.show ? 'site-header-menu-links--show' : ''}`} data-site-header-menu-links>
                    <ul className="dropdown-area-content">
                        <li className="dropdown-area-content-list-item">
                            <a className="dropdown-area-content-list-item-link" href="/my/overview" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Översikt">Översikt</a>
                        </li>
                        <li className="dropdown-area-content-list-item">
                            <a className="dropdown-area-content-list-item-link" href="/my/wish-list" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Minneslistan">Minneslista</a>
                        </li>
                        <li className="dropdown-area-content-list-item">
                            <a className="dropdown-area-content-list-item-link" href="/my/saved-searches" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Sparade sökningar">Bevakningar</a>
                        </li>
                        <li className="dropdown-area-content-list-item dropdown-area-content-list-item-end-section">
                            <a className="dropdown-area-content-list-item-link" href="/my/favourite-sellers" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Favoritsäljare">Favoritsäljare</a>
                        </li>
                        <li className="dropdown-area-content-list-item">
                            <a className="dropdown-area-content-list-item-link" href="/my/active-items" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Pågående budgivningar">Pågående budgivningar</a>
                        </li>
                        <li className="dropdown-area-content-list-item">
                            <a className="dropdown-area-content-list-item-link" href="/my/purchases" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Mina köp">Mina köp</a>
                        </li>
                        <li className="dropdown-area-content-list-item dropdown-area-content-list-item-end-section">
                            <a className="dropdown-area-content-list-item-link" href="/my/items-lost" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Ej vunna">Ej vunna</a>
                        </li>
                        <li className="dropdown-area-content-list-item">
                            <a className="dropdown-area-content-list-item-link" href="/my/active" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Aktiva annonser">Aktiva annonser</a>
                        </li>
                        <li className="dropdown-area-content-list-item">
                            <a className="dropdown-area-content-list-item-link" href="/my/sold" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Sålda">Sålda</a>
                        </li>
                        <li className="dropdown-area-content-list-item">
                            <a className="dropdown-area-content-list-item-link" href="/my/unsold" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Ej sålda">Ej sålda</a>
                        </li>
                        <li className="dropdown-area-content-list-item dropdown-area-content-list-item-end-section">
                            <a className="dropdown-area-content-list-item-link" href="/my/sold/picklist" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Plocklista">Plocklista</a>
                        </li>
                        <li className="dropdown-area-content-list-item">
                            <a className="dropdown-area-content-list-item-link" href="/my/leave-feedback/buyer?transactionId=0" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Lämna omdöme på säljare">Lämna omdöme på säljare</a>
                        </li>
                        {this.props.isLoggedIn ?
                            [
                                <li className="dropdown-area-content-list-item" key="fpk">
                                    <a className="dropdown-area-content-list-item-link" href="/my/leave-feedback/seller?transactionId=0" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Lämna omdöme på köpare">Lämna omdöme på köpare</a>
                                </li>,
                                <li className="dropdown-area-content-list-item dropdown-area-content-list-item-end-section" key="mo">
                                    <a className="dropdown-area-content-list-item-link" href={`/profile/feedback/${memberId}/${cleanedMemberAlias}`}>Mina omdömen</a>
                                </li>
                            ]
                            : <li className="dropdown-area-content-list-item dropdown-area-content-list-item-end-section">
                                <a className="dropdown-area-content-list-item-link" href="/my/leave-feedback/seller?transactionId=0" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Lämna omdöme på köpare">Lämna omdöme på köpare</a>
                            </li>
                        }

                        {/*
                        @if (Model.IsLoggedIn) {
                            // @* Note the "dropdown-area-content-list-item-end-section" in this IF if you're doing changes *@
                            <li className="dropdown-area-content-list-item">
                                <a className="dropdown-area-content-list-item-link" href="/my/leave-feedback/seller?transactionId=0" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Lämna omdöme på köpare">Lämna omdöme på köpare</a>
                            </li>
                            <li className="dropdown-area-content-list-item dropdown-area-content-list-item-end-section">
                                <a className="dropdown-area-content-list-item-link" href="@Url.Action(MVC.Profile.Feedback.Index(Model.MemberInfo.MemberId, Model.InitData.CleanedMemberAlias))">Mina omdömen</a>
                            </li>
                        } else {
                            <li className="dropdown-area-content-list-item dropdown-area-content-list-item-end-section">
                                <a className="dropdown-area-content-list-item-link" href="/my/leave-feedback/seller?transactionId=0" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Lämna omdöme på köpare">Lämna omdöme på köpare</a>
                            </li>
                        }
                        */}
                        <li className="dropdown-area-content-list-item">
                            <a className="dropdown-area-content-list-item-link" href="/my/profile" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Inställningar">Inställningar</a>
                        </li>
                        <li className="dropdown-area-content-list-item">
                            <a className="dropdown-area-content-list-item-link" href="/my/Invoices?page=1" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Fakturor och avgifter">Fakturor &amp; avgifter</a>
                        </li>
                        <li className="dropdown-area-content-list-item">
                            <a className="dropdown-area-content-list-item-link" href="/my/Payments" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Betalning">Utbetalningar</a>
                        </li>

                        {
                            this.props.isLoggedIn && this.props.showKlarnaMenu ?
                                <li className="dropdown-area-content-list-item">
                                    <a className="dropdown-area-content-list-item-link" href="/my/klarna" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Klarna">Klarna</a>
                                </li>
                                : null
                        }

                        {/*
                        @if (Model.IsLoggedIn && Model.InitData.PaymentSettings != null && Model.InitData.PaymentSettings.ShowKlarnaMenu) {
                            <li className="dropdown-area-content-list-item">
                                <a className="dropdown-area-content-list-item-link" href="@Url.Action(MVC.MyTradera.Klarna.Index())" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Klarna">Klarna</a>
                            </li>
                        }
                        */}


                        <li className="dropdown-area-content-list-item site-header-menu-login-links">
                            <p>
                                {
                                    this.props.isLoggedIn ?
                                        <a className="dropdown-area-content-list-item-link site-header-menu-login-link col-sm pl-4" href="/login/logout" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Logga ut">Logga ut</a>
                                        :
                                        [
                                            <a key="logga-in" className="site-header-menu-login-link ml-4 pl-2 pr-2" href="/login" data-login-link data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Logga in">Logga in</a>,
                                            '/',
                                            <a key="bli-medlem" className="site-header-menu-login-link mx-2" href="/register" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Bli medlem">Bli medlem</a>
                                        ]
                                }
                            </p>
                        </li>
                        {/* <a className="dropdown-area-content-list-item-link site-header-menu-login-link" href="@(Url.RouteUrl(LoginAreaRegistration.LoginRouteName, null, TouchWebConfig.Instance.DisableHttps ? "http" : "https"))" data-login-link data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Logga in">Logga in</a> */}


                        {/*
                        <li className="dropdown-area-content-list-item site-header-menu-login-links">
                            @if (Model.IsLoggedIn)
                            {
                                <a className="dropdown-area-content-list-item-link site-header-menu-login-link" href="@Url.Action(MVC.Login.Logout.Logout())" data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Logga ut">Logga ut</a>
                            }
                            else
                            {
                                <a className="dropdown-area-content-list-item-link site-header-menu-login-link" href="@(Url.RouteUrl(LoginAreaRegistration.LoginRouteName, null, TouchWebConfig.Instance.DisableHttps ? "http" : "https"))" data-login-link data-ga-category="Header" data-ga-action="Navigation" data-ga-label="Mitt Tradera - Logga in">Logga in</a>
                            }
                        </li>
                        */}
                    </ul>
                </nav>
            </div>
        );
    }
}

MyTraderaMenu.propTypes = {
    isLoggedIn: PropTypes.bool,
    showKlarnaMenu: PropTypes.bool,
    hoverUser: PropTypes.bool,
    cleanedMemberAlias: PropTypes.string,
    memberId: PropTypes.number
};

export default MyTraderaMenu;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/mytradera-menu/mytradera-menu.jsx